import { useCallback, useRef } from "react";

const useDebounceLeading = <T extends (...args: any[]) => void>(callback: T, delay = 300) => {
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  return useCallback(
    (...args: Parameters<T>) => {
      if (!timerRef.current) {
        callback(...args);
      }

      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        timerRef.current = undefined;
      }, delay);
    },
    [callback, delay]
  );
};

export default useDebounceLeading;
